export const buildAttendanceEntries = (
  roster: {
    student: {
      _id: string;
      name: string;
      email: string;
      gradYear: number;
    };
    present: boolean;
    reason: string;
  }[],
): {
  studentId: string;
  present: boolean;
}[] => {
  return roster.map((r) => ({
    studentId: r.student._id,
    present: typeof r.present === "boolean" ? r.present : false,
  }));
};
